import { Box, Stack, Text } from "@chakra-ui/react";
import RotuloClassificacao from "../Catalog/RotuloClassificacao";
import RotuloGri from "../Catalog/RotuloGri";

export default function QuestionCardRespondents({
  question,
  questionType,
  idPillar,
  idTheme,
  pillarName,
  themeTitle,
  gri,
  children,
}) {
  return (
    <Stack
      spacing={["16px", "24px"]}
      align="start"
      p="24px"
      bg="white"
      borderRadius="12px"
      mt={["12px", "24px"]}
      pos="relative"
    >
      <Box>
        <Text
          fontSize={["14px", "16px"]}
          lineHeight="22px"
          fontWeight={500}
          mt="10px"
        >
          <b>{questionType}</b> -{" "}
          <Text as="span" dangerouslySetInnerHTML={{ __html: question }} />
        </Text>

        {/* Pilar/Tema e indicadores GRI da questão, como nos demais cards
            (Question-card-custom / -certification). Só depende de o payload
            de /link_user_question mandar id_pillar/id_theme/gri. */}
        <RotuloClassificacao
          idPillar={idPillar}
          idTheme={idTheme}
          pillarName={pillarName}
          themeTitle={themeTitle}
          ocultarVazio
        />
        <RotuloGri gri={gri} comRotulo />
      </Box>
      {children}
    </Stack>
  );
}
